import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Cookies from 'js-cookie';

import * as answerActionCreators from '../actions/answers';
import * as commentActionCreators from '../actions/comments';
import * as fetchActionCreators from '../actions/fetching';
import * as navigationActionCreators from '../actions/navigation';

import Loading from './Loading';
import Error from './Error';

class App extends React.Component {

  componentDidMount() {
    if (this.props.hash) {
      Cookies.set('q360Hash', this.props.hash, { expires: 3 });
    }

    if (this.props.loading) {
      const hashFromCookie = Cookies.get('q360Hash');
      this.props.fetchSurveyData(hashFromCookie);
    }
  }

  render() {
    if (this.props.error && this.props.error.fetch) {
      return (<Error msg={this.props.error.fetch} />);
    }

    if (this.props.loading) {
      return (<div class='mar80'><h1><Loading size={3} /></h1></div>);
    }

    return (
      <div id='root' class='container'>
        <div id='main-row' class='row'>
          {React.cloneElement({ ...this.props }.children, { ...this.props })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  if (!state.pages['1']) { // no data
    return {
      loading: true,
      hash: ownProps.params.hash,
      error: state.error
    };
  }

  const statementCount = state.pages['1'].length;
  const status = Object.keys(state.evals).map(function (key) {
    const answerCount =
      (state.answers[key] ? Object.keys(state.answers[key]).length / statementCount : 0) +
      (state.textAnswers[key] ? 1 : 0);
    const questionCount = (Object.keys(state.statements).length / statementCount) + 1;
    // +1 because the text q
    return {
      id: key,
      name: state.evals[key].name,
      percentage: (answerCount / questionCount) * 100,
      nickname: state.evals[key].nickname
    };
  }).sort((x, y) => {
    // sort self eval to 0 index
    const isXSelfEval = x.id === state.user;
    const isYSelfEval = y.id === state.user;

    return isXSelfEval ? -1 :
      isYSelfEval ? 1 : 0;
  });

  const currentEval = ownProps.params.eval;
  const nextEvalIndex = currentEval ? status.map(s => s.id).indexOf(currentEval) + 1 : 0;
  const evalOrder = [...status.slice(nextEvalIndex), ...status.slice(0, nextEvalIndex)];

  const notFinished = evalOrder.filter(s => s.percentage !== 100);
  const nextEval = notFinished[0] && notFinished[0].id !== currentEval ? notFinished[0] : { id: 'end' };

  return {
    status,
    nextEval,
    langType: state.lang,
    lang: state.langKeys,
    hash: ownProps.params.hash,
    user: state.user,
    surid: state.surid,
    error: state.error,
    customWelcomeText: state.customWelcomeText,
    customEndText: state.customEndText,
    pointsPerStatement: state.pointsPerStatement
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...answerActionCreators,
      ...commentActionCreators,
      ...fetchActionCreators,
      ...navigationActionCreators,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
